import React from 'react';
import type { ReactNode } from 'react';
import { cx } from '../../../utils/cx';

const SEMANTIC_NAME = 'RomaContentDivider';

export type ContentDividerProps = {
    type: 'single-line' | 'dual-line' | 'background-fill';
    children?: ReactNode;
    className?: string;
};

const styles = {
    'single-line': 'flex items-center gap-x-2',
    'dual-line': 'flex justify-center gap-x-2 border-y border-secondary py-3',
    'background-fill': 'flex justify-center gap-x-2 rounded-lg bg-secondary py-2',
};

export const ContentDivider = ({ type, children, className }: ContentDividerProps) => {
    return (
        <div className={cx(SEMANTIC_NAME, 'w-full shrink-0 text-md text-tertiary', styles[type], className)}>
            {type === 'single-line' && <div className="h-px flex-1 bg-border-secondary" />}
            {children}
            {type === 'single-line' && children != null && <div className="h-px flex-1 bg-border-secondary" />}
        </div>
    );
};

ContentDivider.displayName = SEMANTIC_NAME;
